import styled from "styled-components/macro";

export const PortalAuthLayout = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  min-height: 100vh;
  min-height: 100dvh;
  background-color: ${({ theme }) => theme.white};

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

export const PortalAuthBrandPanel = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  min-height: 100vh;
  min-height: 100dvh;
  position: relative;
  background: ${({ theme }) => theme.gradient};

  @media (max-width: 900px) {
    display: none;
  }
`;

export const PortalAuthBrandAccent = styled.img`
  position: absolute;
  left: 57%;
`;

export const PortalAuthBrandLogo = styled.img<{ $width: string }>`
  width: ${({ $width }) => $width};
  margin: auto;
`;

export const PortalAuthContentPanel = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px 20px;
`;

export const PortalAuthContentShell = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  place-items: center;
  text-align: center;
  width: 100%;
  max-width: 447px;
`;

export const PortalAuthTitle = styled.h1<{ $isError: boolean }>`
  margin: 0;
  color: ${({ theme, $isError }) =>
    $isError ? theme.redDark : theme.greyMedium};
  font-size: 20px;
  font-weight: 700;
  line-height: 1.2;
  text-align: center;
`;

export const PortalAuthMessage = styled.p`
  width: 100%;
  margin: 24px 0 0;
  color: ${({ theme }) => theme.greyMedium};
  font-size: 16px;
  font-weight: 400;
  line-height: 1.4;
  text-align: center;
`;

export const PortalAuthSpinnerWrapper = styled.div`
  margin-top: 32px;
`;

export const PortalAuthActions = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  place-items: center;
  gap: 16px;
  margin-top: 28px;
`;
